export const GET_QUOTE_GENERIC_ERROR_MESSAGE =
  'Unfortunately we can not get an estimate to deliver to this location right now. Please try again later.';
